module.exports = __webpack_public_path__ + "static/media/background-header.af69519d.svg";